import React, { useEffect, useState } from "react";

const REDIRECT_URL = "https://ecoprism.com/";
const COUNTDOWN_SECONDS = 4;

const SurveyThankYou = ({
  title = "Thank you for your survey!",
  message = "We have received your responses. You can safely close this page.",
}) => {
  const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          window.location.href = REDIRECT_URL;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div id="wrapper">
      <header>
        <nav className="navbar navbar-expand-lg navbar-light" style={{ background: "#407775" }}>
          <div className="container-fluid">
            <a className="navbar-brand" href="#home">
              <img src="assets/img/logo.png" alt="Company Logo" height="30" className="d-inline-block align-top" />
            </a>
          </div>
        </nav>
      </header>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "calc(100vh - 56px)",
          background: "#fff",
        }}
      >
        <div style={{ textAlign: "center", padding: "48px 40px", maxWidth: "500px", width: "100%" }}>
          <div
            style={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              background: "#407775",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 28px",
            }}
          >
            <svg
              width="36"
              height="36"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#fff"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h2 style={{ color: "#407775", fontWeight: 700, fontSize: "28px", marginBottom: "16px" }}>
            {title}
          </h2>
          <p
            style={{
              fontSize: "16px",
              color: "#666",
              lineHeight: "1.6",
              maxWidth: "380px",
              margin: "0 auto 16px",
            }}
          >
            {message}
          </p>
          <p style={{ fontSize: "14px", color: "#888" }}>
            Redirecting to{" "}
            <a href={REDIRECT_URL} style={{ color: "#407775" }}>ecoprism.com</a>{" "}
            in {countdown} second{countdown !== 1 ? "s" : ""}...
          </p>
        </div>
      </div>
    </div>
  );
};

export default SurveyThankYou;
